function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M150,10.5A98.62,98.62,0,0,0,51.5,109V226.5H95A9.53,9.53,0,0,0,104.5,217V138A9.53,9.53,0,0,0,95,128.5H68.5V109a81.5,81.5,0,0,1,163,0v19.5H205A9.53,9.53,0,0,0,195.5,138v79A9.53,9.53,0,0,0,205,226.5h24.84c-4.38,12.6-17.27,23.63-35.35,30.09V255A9.53,9.53,0,0,0,185,245.5H133A9.53,9.53,0,0,0,123.5,255V280A9.53,9.53,0,0,0,133,289.5H185A9.53,9.53,0,0,0,194.5,280v-5.51c32.57-9.72,54-32.22,54-57.46V109A98.62,98.62,0,0,0,150,10.5Zm-62.5,135v64h-19v-64Zm90,127h-37v-10h37Zm35-127h19v64h-19Z"
});

var SvgSupport = function SvgSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/support.bfff9c11.svg";
export { ForwardRef as ReactComponent };